// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2armi","question":"Question_question__2hJ35","description":"Question_description__-MOp1"};